import { CompanionError } from '../_internal/error/CompanionError';
export const MIME_TYPES = {
    flv: 'video/x-flv',
    mkv: 'video/x-matroska',
    m2t: 'video/MP2T',
    mts: 'video/MP2T',
    mp4: 'video/mp4',
    webm: 'video/webm',
    '3gp': 'video/3gpp',
    avi: 'video/x-msvideo',
    wmv: 'video/x-ms-wmv',
    mov: 'video/quicktime',
    aac: 'audio/aac',
    mp3: 'audio/mpeg',
    ogg: 'audio/ogg',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
    webp: 'image/webp',
    gif: 'image/gif',
    xml: 'application/xml',
};
/**
 * Sanitize filename string
 */
export function cleanFilename(name) {
    // Remove file extension
    let cleanFilename = name.replace(/\.[^/.]+$/, '');
    // Replace underscores and multiple -- to spaces, and then capitalize each word in the title
    cleanFilename = cleanFilename.replace(/(_|-{2,})/g, ' ').replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    return cleanFilename;
}
export function getExtensionFromFile(file, types = MIME_TYPES) {
    const extension = file.name.split('.').pop();
    if (extension && extension in types) {
        return extension;
    }
    throw new CompanionError({
        error: new Error('File has unknown or invalid type.'),
        code: 'TYPE_INVALID',
    });
}
getExtensionFromFile.ERR = {
    TYPE_INVALID: 'TYPE_INVALID',
};
export function getMimeTypeFromFile(file, types = MIME_TYPES) {
    if (file.type) {
        // Prefer file's type if it's not empty
        return file.type;
    }
    // Assert extension
    const extension = file.name.split('.').pop();
    if (extension && extension in types) {
        return types[extension];
    }
    throw new CompanionError({
        error: new Error('File has unknown or invalid MIME type.'),
        code: 'MIME_INVALID',
    });
}
getMimeTypeFromFile.ERR = {
    MIME_INVALID: 'MIME_INVALID',
};
export function assertTitle(file, existingTitle, clean) {
    if (existingTitle) {
        // Prefer custom title
        return existingTitle;
    }
    // Check if filename needs to be cleaned
    if (clean) {
        return cleanFilename(file.name);
    }
    // Return filename as-is
    return file.name;
}
